module.exports = __webpack_public_path__ + "img/TZS09555.96ddca90.jpeg";